import _ from "lodash"
import Vue from 'vue'

import moment from "moment";
import constants from '@/rules/constants'
import acl from '@/rules/acl_rules';

var Base64 = {
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    encode: function(e) {
        if(typeof e == "undefined" || e == false || e == null || e == ""){
            return e;
        }
        var t = "";
        var n, r, i, s, o, u, a;
        var f = 0;
        e = Base64._utf8_encode(e);
        while (f < e.length) {
            n = e.charCodeAt(f++);
            r = e.charCodeAt(f++);
            i = e.charCodeAt(f++);
            s = n >> 2;
            o = (n & 3) << 4 | r >> 4;
            u = (r & 15) << 2 | i >> 6;
            a = i & 63;
            if (isNaN(r)) { u = a = 64 } else if (isNaN(i)) { a = 64 }
            t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a)
        }
        return t
    },
    decode: function(e) {
        if(typeof e == "undefined" || e == false || e == null || e == ""){
            return e;
        }
        var t = "";
        var n, r, i;
        var s, o, u, a;
        var f = 0;
        e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (f < e.length) {
            s = this._keyStr.indexOf(e.charAt(f++));
            o = this._keyStr.indexOf(e.charAt(f++));
            u = this._keyStr.indexOf(e.charAt(f++));
            a = this._keyStr.indexOf(e.charAt(f++));
            n = s << 2 | o >> 4;
            r = (o & 15) << 4 | u >> 2;
            i = (u & 3) << 6 | a;
            t = t + String.fromCharCode(n);
            if (u != 64) { t = t + String.fromCharCode(r) }
            if (a != 64) { t = t + String.fromCharCode(i) }
        }
        t = Base64._utf8_decode(t);
        return t
    },
    _utf8_encode: function(e) {
        if(typeof e == "undefined" || e == false || e == null || e == ""){
            return e;
        }
        e = e.replace(/\r\n/g, "\n");
        var t = "";
        for (var n = 0; n < e.length; n++) {
            var r = e.charCodeAt(n);
            if (r < 128) { t += String.fromCharCode(r) } else if (r > 127 && r < 2048) {
                t += String.fromCharCode(r >> 6 | 192);
                t += String.fromCharCode(r & 63 | 128)
            } else {
                t += String.fromCharCode(r >> 12 | 224);
                t += String.fromCharCode(r >> 6 & 63 | 128);
                t += String.fromCharCode(r & 63 | 128)
            }
        }
        return t
    },
    _utf8_decode: function(e) {
        if(typeof e == "undefined" || e == false || e == null || e == ""){
            return e;
        }
        var t = "";
        var n = 0;
        var r  = 0;
        var c1 = 0; 
        var c2 = 0;
        while (n < e.length) {
            r = e.charCodeAt(n);
            if (r < 128) {
                t += String.fromCharCode(r);
                n++
            } else if (r > 191 && r < 224) {
                c2 = e.charCodeAt(n + 1);
                t += String.fromCharCode((r & 31) << 6 | c2 & 63);
                n += 2
            } else {
                c2 = e.charCodeAt(n + 1);
                c3 = e.charCodeAt(n + 2);
                t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                n += 3
            }
        }
        return t
    }
}
var capitalizeFirstLetter = (string)=> {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

var getLoggedUser = ()=>{
    var s = document.cookie.split(";")
    var ret ="-";
    s.forEach((c) => {
        var kv = c.trim().split("=")
      if (kv[0] == "session_user" && kv[1].length > 0) {
        ret = kv[1];
        if (typeof this.$store != "undefined") {
            this.$store.state.logged_user = kv[1];
        }
      }
    })
    return capitalizeFirstLetter(ret);
}
var getLoggedUserDisplay = ()=>{
    var s = document.cookie.split(";")
    var ret ="-";
    s.forEach((c) => {
        var kv = c.trim().split("=")
      if (kv[0] == "session_display_user_name" && kv[1].length > 0) {
        ret = kv[1];
      }
      if (kv[0] == "session_user" && kv[1].length > 1) {
          if (typeof this.$store != "undefined") {
              this.$store.state.logged_user = kv[1];
          }
      }
    })
    return decodeURIComponent(ret);
}

var copyAllowed = (allowed,data) => {
    allowed = "all" // TODO, it is temporary only, should be fixed later. as is a secutiry issue
    var ret = {}
    var i = 0
    for(var d  in data){
        if (allowed== "all" || allowed.indexOf(d) > -1){
            ret[d] = data[d];
            i++;
        }
    }
    if(i == 0){
        ret = false
    }
    return ret
}

var if_null = (val,def="")=>{
    if(typeof val == "undefined" || val == null | val == false || val == ""){
        return def;
    }else{
        return val
    }
}

var format_date = (d) =>{
    if(typeof d == "undefined" || d == false || d == null || d == ""){
        return "";
    }
    return moment(d).format("YYYY/MM/DD");
}
var format_date_time = (dt) =>{
    if(typeof dt == "undefined" || dt == false || dt == null || dt == ""){
        return "";
    }
    return moment(dt).format("YYYY/MM/DD HH:mm");
}
var format_date_time_s = (dt) =>{
    if(typeof dt == "undefined" || dt == false || dt == null || dt == ""){
        return "";
    }
    return moment(dt).format("YYYY/MM/DD HH:mm:ss");
}

var local_user_permissions =  false;
var reset_user_permissions = ()=>{
  local_user_permissions =  false;
}
var get_user_permissions = ()=>{
  if(local_user_permissions == false){
    var temp = Vue.localStorage.get("userRole")
    switch (temp) {
      case constants.PERMISSION.ID_OPERATIONS_PERSONNEL:
        local_user_permissions = constants.PERMISSION.ID_OPERATIONS_PERSONNEL;
        break;
      case constants.PERMISSION.ADMINISTRATOR:
        local_user_permissions = constants.PERMISSION.ADMINISTRATOR;
        break;
      case constants.PERMISSION.CHIEF_ADMINISTRATOR:
        local_user_permissions = constants.PERMISSION.CHIEF_ADMINISTRATOR;
        break;
      case constants.PERMISSION.SYSTEM_ADMINISTRATOR:
        local_user_permissions = constants.PERMISSION.SYSTEM_ADMINISTRATOR;
        break;
      case constants.PERMISSION.MAINTENANCE_STAFF:
        local_user_permissions = constants.PERMISSION.MAINTENANCE_STAFF;
        break;
      default:
        local_user_permissions = constants.PERMISSION.NONE;
        break;
    }
  }
  return local_user_permissions;
}
var check_user_permission = (page_acl,permission ,requester="") =>{
  var user_role = get_user_permissions();
  if(Array.isArray(page_acl.full) &&  page_acl.full.indexOf(user_role)> -1){
    return true;
  }
  if(Array.isArray(page_acl[permission]) && page_acl[permission].indexOf(user_role) > -1){
    return true;
  }
  return false;
}

export const utils = {
// extend ver se da para usar o lodash
  extend: _.extend,
  cextend: (data,ext)=>{
    var d = _.clone(data)
    return _.extend(d,ext)

  },
  _:_,
  format_date:format_date,
  format_date_time:format_date_time,
  format_date_time_s:format_date_time_s,
  groupBy: _.groupBy,
  orderBy:_.orderBy,
  filter:_.filter,
  remove:_.remove,
  Base64:Base64,
  copyAllowed :copyAllowed,
  getLoggedUser:getLoggedUser,
  getLoggedUserDisplay:getLoggedUserDisplay,
  test: (d)=>{
      return "---" + d +  "---";
  },
  if_null:if_null,
  get_user_permissions:get_user_permissions,
  reset_user_permissions:reset_user_permissions,
  check_user_permission:check_user_permission,
  acl:acl,
  PERMISSION_MODE:constants.PERMISSION_MODE,
  constants:constants
}
window.addEventListener("storage", (ev)=>{
  if(ev.key == "userRole"){
    utils.reset_user_permissions();
  }
});


// WEBPACK FOOTER //
// ./src/libs/utils.js